import { HistoryLocation } from '@reach/router';
import noop from 'lodash/noop';
import React from 'react';

import type { GA4Event, GA4Pageview, GAEventData, GAPageviewData } from './types';

export type Context = {
	sendEvent(eventData: GAEventData | GA4Event, eventExtra?: Record<string, unknown>): void;
	sendPageview(
		pageviewData: GAPageviewData | GA4Pageview,
		previousLocation?: HistoryLocation | null
	): void;
};

const GoogleAnalyticsContext = React.createContext<Context>({
	sendEvent: noop,
	sendPageview: noop,
});

export default GoogleAnalyticsContext;
